module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e2597"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2647"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c16_r1#Anch0007",
      "id": "Anch0019"
    }
  }, [_c('b', [_vm._v("Section One: The Daddy Difference ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2697"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c17_r1#Anch0027",
      "id": "Anch00311"
    }
  }, [_vm._v("1. The Missing Ingredient ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2747"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c18_r1#Anch0047",
      "id": "Anch00525"
    }
  }, [_vm._v("2. That Man Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2797"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c19_r1#Anch0067",
      "id": "Anch00745",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A New Meaning to the Family Bed")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2857"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c20_r1#Anch0087",
      "id": "Anch00957",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Daddy Attention Deficit Disorder (DADD)")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2937"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c21_r1#Anch0107",
      "id": "Anch01177",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Section Two: Daddy’s Duty ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2987"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c22_r1#Anch0127",
      "id": "Anch01379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Good Dad")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c23_r1#Anch0147",
      "id": "Anch015101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Make Waffles, Not Wafflers")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3117"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c24_r1#Anch0167",
      "id": "Anch017111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Miss Trust")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3167"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c25_r1#Anch0187",
      "id": "Anch019127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Blessing Kids with Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3227"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c26_r1#Anch0207",
      "id": "Anch021141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Love Them Differently")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3277"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c27_r1#Anch0227",
      "id": "Anch023163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. God Doesn’t Want to Be First in Your Daughter’s Life")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3327"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c28_r1#Anch0247",
      "id": "Anch025175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Teach Your Daughter That Other People Matter More")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3377"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c29_r1#Anch0287",
      "id": "Anch029187",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Section Three: Daddy’s Dilemmas")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3427"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c29.1_r1#Anch0307",
      "id": "Anch031189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. When Mother and Daughter Collide (and Daddy Is in the Middle) ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3507"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c29.11_r1#Anch0327",
      "id": "Anch033199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. When Daughter Develops ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3567"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c30_r1#Anch0347",
      "id": "Anch035217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Father-in-Law")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3617"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c31_r1#Anch0367",
      "id": "Anch037225",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Awfully Long Aisle ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3667"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c32_r1#Anch0387",
      "id": "Anch039243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3717"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Lema_9781418514020_epub_c35_r1#Anch0407",
      "id": "Anch041249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a362c5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lema_9781418514020_epub_c15_r1.vue
// module id = 69
// module chunks = 0